export default (name) => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');

    var container = {};
    window.location.search.split('&').toString().substr(1).split(",").forEach(item => {
        container[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]) ?  item.split("=")[1]: "No query strings available" ;
    });

    if (container && container[name]) {
        return container[name];
    } else {
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));    
    }
};